<template>
  <div>
    <slot></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>圖片 {{imageMemo}}</th>
        <th v-if="mode && mode===2">日期</th>
        <th>說明</th>
        <th v-if="mode &&mode===2">備註</th>
        <th v-if="mode &&mode===3">相簿網址</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
        </td>
        <td width="300px">
          <img :src="convertToRealUrl(item.Url)" style="width:300px;height: 200px">
          <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" ></FileUploadButton>
        </td>
        <td v-if="mode &&mode===2">
          <input type="date" class="form-control" placeholder="" v-model="item.Date">
        </td>
        <td >
          <textarea class="form-control" rows="7" v-model="item.Desc"></textarea>
        </td>
        <td v-if="mode &&mode===2">
          <textarea class="form-control" rows="7" v-model="item.Memo"></textarea>
        </td>
        <td v-if="mode &&mode===3">
          <input type="text" class="form-control"  placeholder="" v-model="item.PhotoUrl">
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 無欄位 日期/備註
 <ListEditImage :mode="1"></ListEditImage>

 有欄位 日期/備註
 <ListEditImage :mode="2"></ListEditImage>

 有相簿位置
 <ListEditImage :mode="3"></ListEditImage>

 options
  image-memo="(建議圖片大小:100x100)"
 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import Vue from "vue";
export default {
  components: {FileUploadButton},
  //name: "imageListUpload",
  props: ["datas","mode","imageMemo"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo:[
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x500",
          Desc:"內文說明活動說明照片說明",
          Date:"",
          Memo:"",
          PhotoUrl:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x501",
          Desc:"內文說明活動說明照片說明",
          Date:"",
          Memo:"",
          PhotoUrl:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x502",
          Desc:"內文說明活動說明照片說明",
          Date:"",
          Memo:"",
          PhotoUrl:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x503",
          Desc:"內文說明活動說明照片說明",
          Date:"",
          Memo:"",
          PhotoUrl:"",
        },
      ]
    };
  },
  methods: {
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={};

      if (this.mode || this.mode===1){
        newItem=
            {
              SystemId:"",
              OrderKey:"",
              Url:"",
              Desc:"",
            };
      } else if (this.mode===2){
        newItem=
            {
              SystemId:"",
              OrderKey:"",
              Url:"",
              Desc:"",
              Date:"",
              Memo:"",
            };
      } else if (this.mode===3){
        newItem=
            {
              SystemId:"",
              OrderKey:"",
              Url:"",
              Desc:"",
              PhotoUrl:"",
            };
      }

      newItem.SystemId =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Remove(item){// eslint-disable-line
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.Url=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },

  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
